import request from "@/service";

/* 查询所有公告列表 */
export function getNoticeParamList(params) {
  return request({
    url: `/study/class/notice/page`,
    method: "get",
    params
  });
}

/* 新增公告 */
export function noticeSave(data) {
  return request({
    url: `/study/class/notice/save`,
    method: "post",
    data
  });
}

/* 修改公告 */
export function noticeUpdate(data) {
  return request({
    url: `/study/class/notice/update`,
    method: "put",
    data
  });
}

/* 删除公告 */
export function noticeDel(data) {
  return request({
    url: `/study/class/notice/delete`,
    method: "delete",
    data
  });
}

/* 上下线 */
export function noticeOnline(uuid, status) {
  return request({
    url: `/study/class/notice/online/${uuid}/${status}`,
    method: "get"
  });
}

/* 拖拽排序 */
export function noticeDrag(data) {
  return request({
    url: "/study/class/notice/drag",
    method: "put",
    data
  });
}
